module.exports = __webpack_public_path__ + "static/media/june2024-4.1906f646.webp";